import React from 'react'

import { Collapsible } from '@base-ui/react/collapsible'
import styled from 'styled-components'
import { border, color, flexbox, layout, space } from 'styled-system'
import { ChevronDown } from 'react-feather'
import { Text } from '@utils/Typography'
import shouldForwardProp from '@styled-system/should-forward-prop'
import { gap } from '../primitives/Layout'

const StyledNavTrigger = styled(Collapsible.Trigger)
  .withConfig({ shouldForwardProp })
  .attrs(props => ({
    justifyContent: 'space-between',
    flexDirection: 'row',
    background: '#fafafa',
    borderRadius: 8,
    gap: 2,
    color: '#585859',
    py: 2,
    px: 3,
    mb: 1,
    ...props
  }))(
  {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    margin: 0,
    border: 0,
    cursor: 'pointer',
    textAlign: 'left',
    font: 'inherit',
    '& svg': {
      flexShrink: 0,
      transition: 'transform 120ms ease-out'
    },
    '&[data-panel-open] svg': {
      transform: 'rotate(180deg)'
    }
  },
  gap,
  flexbox,
  color,
  space,
  layout,
  border
)

export const CollapsibleNavTrigger = ({ color, children, ...props }) => {
  return (
    <StyledNavTrigger {...props}>
      <Text fontSize={1} color="inherit">
        {children}
      </Text>
      <ChevronDown width={18} height={18} color={color} />
    </StyledNavTrigger>
  )
}

export const CollapsibleNav = ({ Trigger, children }) => {
  return (
    <Collapsible.Root defaultOpen={false}>
      <Trigger />
      <Collapsible.Panel>{children}</Collapsible.Panel>
    </Collapsible.Root>
  )
}
